// extracted by mini-css-extract-plugin
export var parcelRow = "_sh-0";